import { IVesselOnePart } from "@tedivo/tedivo-bay-grid-pure";

export function findComposedRefId(
  slotRefId: string,
  calculatedSlots: IVesselOnePart[],
) {
  const isBay = !isNaN(Number(slotRefId));

  if (!isBay) return slotRefId;

  for (let i = 0; i < calculatedSlots.length; i++) {
    const s = calculatedSlots[i];
    const bays = s.id.split("-");
    if (bays.indexOf(slotRefId) >= 0) return s.id;
  }

  return "";
}
